export const SUPPORT_EMAIL_ADDRESS = 'support@getduckbill.com';
